<template lang="pug">
div
  div(v-if="!editMode" style="display: flex; justify-content: space-between;")
    div {{ formatterUtils.moneyFormatter(user.driverPaymentPerDelivery) }}
    b-button.mr-2.mb-1.boton-editar(@click="showForm")
      .material-icons edit
  div(v-else)
    b-form(@submit.stop.prevent="onSubmit")
      input(type="number" v-model="form.driverPaymentPerDelivery")
      div.mt-2(style="display: flex; gap: 8px; width: 100%;")
        b-button(@click="onSubmit" size="sm") Guardar
        b-button(@click="onCancel" variant="outline-danger" size="sm") Cancelar
</template>

<script>
import roles from '../../common/roles'
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import MakeToastMixin from '../mixins/MakeToastMixin'
import formatterUtils from '../../utils/formatterUtils'

export default {
  mixins: [MakeToastMixin],
  props: {
    user: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      formatterUtils,
      editMode: false,
      form: {
        driverPaymentPerDelivery: this.user.driverPaymentPerDelivery
      },
      roles: roles
    }
  },
  validations () {
    const form = {
      driverPaymentPerDelivery: { required }
    }
    return { form }
  },
  methods: {
    ...mapActions(['updateUser']),
    onSubmit () {
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        this.onUpdateUser()
      }
    },
    resetForm () {
      this.form = {
        driverPaymentPerDelivery: this.editMode ? this.user.driverPaymentPerDelivery : ''
      }
    },
    showForm () {
      this.editMode = true
      this.resetForm()
    },
    onCancel () {
      this.editMode = false
      this.resetForm()
    },
    hideForm () {
      this.editMode = false
      this.resetForm()
    },
    async onUpdateUser () {
      const data = { ...this.form }
      const response = await this.updateUser({ id: this.user.id, data })
      if (response.status === 200) {
        this.makeSuccessToast('El pago por envío se editó correctamente')
        this.user.driverPaymentPerDelivery = this.form.driverPaymentPerDelivery
        this.$emit('done')
        this.hideForm()
      } else if (response.status >= 400) {
        this.makeDangerToast(response.data.message || 'Error al editar el pago por envío')
      }
    }
  }
}
</script>
